import React from 'react';
import { IconType } from 'react-icons';
import { Link } from 'react-router-dom';
import Button, { ButtonVariant } from '../Buttons/Button';
import ResponsiveContainer from '../../layouts/ResponsiveContainer';
import us_img from '../../assets/img/img-contactsus.png'

interface CTABoxProps {
    title?: string;
    linkPath: string;
    buttonLabel: string;
    buttonIcon?: IconType;
    background?: string;
    classNameContainer?: string;
    variant?: 'default' | 'redesign';
    buttonVariant?: ButtonVariant;
    buttonClassName?: string;
}

const CTABox: React.FC<CTABoxProps> = ({
    title = "¿Tenés dudas o consultas?",
    linkPath,
    buttonLabel,
    buttonIcon = undefined,
    background = 'bg-[#D7D9E5]/30',
    classNameContainer = 'mt-10 mb-12',
    variant = 'default',
    buttonVariant = 'primary',
    buttonClassName = '',
}) => {
    const isRedesign = variant === 'redesign';

    return (
        <div className={`flex flex-col justify-center w-full items-center ${classNameContainer}`}>
            <ResponsiveContainer className={`${background} rounded-sm relative z-6102858 overflow-hidden`}>
                <div className={`flex py-6 px-8 ${isRedesign ? 'flex-row items-center justify-between' : 'flex-col gap-2'}`}>
                    <div className='flex flex-col gap-2 w-full relative z-10 md:static'>
                        <h4 className={`${isRedesign ? 'text-hsmall md:text-dsmall text-brand-green-20' : 'text-tlarge text-primary-10'}`}>{title}</h4>
                        <Link to={linkPath} className="w-max">
                            <Button
                                label={buttonLabel}
                                icon={buttonIcon}
                                as='link'
                                variant={buttonVariant}
                                className={buttonClassName}
                            />
                        </Link>
                    </div>
                    {isRedesign && (
                        <div className='absolute top-[0.3125rem] right-[-3.375rem] sm:top-[-1.75rem] md:top-[-2rem] lg:right-[-1.5rem]'>
                            <img src={us_img} alt="imagen-contactanos" className='w-[15.625rem] sm:w-[18.75rem] md:w-[22rem] md:h-[14.25rem]' />
                        </div>
                    )}
                </div>
            </ResponsiveContainer>
        </div>
    );
}

export default CTABox;